"use client";

import dynamic from "next/dynamic";
import { buildSemanticChartData } from "@/lib/charts/buildChartData";
import type { SemanticChartData } from "@/lib/charts/types";

// Chart.js must not execute during static-build SSR — same pattern as the
// calculator/comparison education sections. Only the canvas hydrates; the
// figure, title, and caption around it are server-rendered by BlogChart.
const Chart = dynamic(() => import("@/components/ui/Chart"), { ssr: false });

interface BlogChartCanvasProps {
  chartData: SemanticChartData;
}

export default function BlogChartCanvas({ chartData }: BlogChartCanvasProps) {
  return (
    <Chart
      type={chartData.type}
      data={buildSemanticChartData(chartData)}
      height={300}
    />
  );
}
